<template>
  <!-- 项目概况 -->
  <div class="main">
    <!-- 标题行 -->
    <div class="titleRow">
      <div class="title">
        <el-divider direction="vertical"></el-divider>
        <span>项目概况</span>
      </div>

      <div class="options">
        <el-image :src="relateFolder"></el-image>
        <el-link type="primary" :disabled="!currentPrjId" @click="fileDialog = true">关联文件夹</el-link>
      </div>
    </div>

    <!-- 展示区 -->
    <div class="showArea">
      <!-- 暂无概况 -->
      <div v-if="imgList.length == 0" class="notOverview">
        <el-image style="width: 280px; height: 220px" :src="notOverview" fit="contain"></el-image>
      </div>

      <!-- 有概况图片 -->
      <template v-if="imgList.length">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="img in imgList" :key="img.fileId">
            <el-image :src="imgUrl(img)" fit="cover" :preview-src-list="srcList"></el-image>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>

    <!-- 通用关联文件 -->
    <el-dialog v-dialogDrag title="关联文件夹" :visible.sync="fileDialog" width="540px" :close-on-click-modal="false"
      :close-on-press-escape="false" @open="getlocalTree(node_had,resolve_had)" @close="closeFileDialog">
      <el-tree ref="localTree" node-key="folderId" :load="getlocalTree" :data="localTree" :props="defaultFileProps"
        :check-on-click-node="true" class="localTree" lazy accordion highlight-current @node-click="handleNodeClick">
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fileDialog = false">取 消</el-button>
        <el-button v-preventReClick type="primary" size="small" @click="filerecelocationBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import { getToken } from "@/CommonDP/utils";

export default {
  components: {},
  props: ["currentPrjId"],
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"), // 文件图标
      notOverview: require("@/CommonDP/assets/workProjectBoard/notOverview.png"), // 暂无概况
      relateFolder: require("@/CommonDP/assets/workProjectBoard/relateFolder.png"), // 关联文件夹
      imgList: [], // 图片列表
      associatedFolderId: "", // 关联文件夹id
      associatedFolderLocation: [], // 关联文件夹位置

      fileDialog: false, // 关联文件弹框
      localTree: [], // 关联文档树
      node_had: {},
      resolve_had: {},
      currentFolder: {}, // 选中的文件夹
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),

    // 图片地址列表
    srcList() {
      let list = this.imgList || [];
      list = list.map(item => this.imgUrl(item));
      return list;
    }
  },
  watch: {
    currentPrjId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.imgList = [];
          this.associatedFolderId = "";
          this.associatedFolderLocation = [];
          this.getOverviewImgs();
          this.getAssociatedFolderLocation();
        }
      }
    }
  },
  mounted() {},
  methods: {
    // 文件图标
    className(row) {
      return tableRowIcon(row);
    },
    // 获得项目概况图片
    async getOverviewImgs() {
      const res = await workProjectBoardService.getOverviewImgs(this.currentPrjId);
      this.imgList = res.data;
    },
    // 预览图片
    imgUrl(img) {
      return `${img}?token=${getToken()}`;
    },
    // 关联文件夹位置
    async getAssociatedFolderLocation() {
      const res = await workProjectBoardService.getAssociatedFolderId(this.currentPrjId);
      this.associatedFolderId = res.data;
      if (this.associatedFolderId) {
        const result = await workProjectBoardService.getAssociatedFolderLocation(this.associatedFolderId);
        this.associatedFolderLocation = result.data;
      } else {
        this.associatedFolderLocation = [];
      }
    },

    // 文件树加载
    async getlocalTree(node, resolve) {
      let list = [];
      if (node.level == 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId: this.currentPrjId
        };
        const res = await docService.queryTree(params);
        list = res.data.map(item => {
          const { childFolder = 0 } = item;
          return {
            ...item,
            leaf: childFolder === 0
          };
        }) || [];
        list = list.filter(({ folderName }) => folderName != "回收站");
      } else {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId: this.currentPrjId
        };
        const res = await docService.queryTree(params);
        list = res.data.map(item => {
          const { childFolder = 0 } = item;
          return {
            ...item,
            leaf: childFolder === 0
          };
        }) || [];
      }
      // 文件树展开
      this.$nextTick(() => {
        if (node.childNodes && this.associatedFolderLocation[node.level]) {
          const nodes = node.childNodes;
          const nodeFolder = this.associatedFolderLocation[node.level];
          nodes.forEach(item => {
            if (item.data.folderId == nodeFolder.folderId) {
              item.expanded = true;
              item.loadData();
            }
          });
        }
      });
      // 当前行高亮
      this.$nextTick(() => {
        this.$refs.localTree.setCurrentKey(this.associatedFolderId);
      });
      let listArray = list.map(item => {
        const { childFolder = 0 } = item;
        return {
          isRead: item.isRead,
          priviAll: item.priviAll,
          folderName: item.folderName,
          folderId: item.folderId,
          isFolder: item.isFolder,
          fileType: item.fileType,
          fileVersion: item.fileVersion,
          status: item.status,
          leaf: childFolder === 0,
          uploadType: 2
        };
      });
      listArray = listArray.filter(item => item.isFolder);
      return resolve(listArray);
    },
    // 文件点击
    async handleNodeClick(data) {
      this.currentFolder = data;
    },
    // 选中确定
    async filerecelocationBtn() {
      if (this.currentFolder.folderId) {
        await workProjectBoardService.associatedFolder(this.currentPrjId, this.currentFolder.folderId);
        await this.getOverviewImgs();
        await this.getAssociatedFolderLocation();
        this.$message.success("关联成功");
      }
      this.fileDialog = false;
    },

    // 离开弹框
    closeFileDialog() {
      this.localTree = [];
      this.currentFolder = {};
    }
  }
};
</script>

<style lang='scss' scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .titleRow {
    width: 100%;
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      display: flex;
      align-items: center;

      .el-divider {
        width: 3px;
        height: 15px;
        margin-left: 0;
        background: var(--theme-color);
      }

      span {
        font-family: "PingFang SC";
        font-weight: 700;
        font-size: 16px;
        color: var(--key-color);
      }
    }

    .options {
      display: flex;
      align-items: center;

      .el-image {
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
    }
  }

  .showArea {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    padding: var(--big-space);

    .notOverview {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.localTree {
  overflow: auto;
  height: 450px;
  max-height: 450px;
  width: 100%;

  .treeitem {
    display: flex;
    align-items: center;
    user-select: none;

    .img {
      margin-right: 6px;
      height: 16px;
      width: 18px;
      user-select: none;
    }
  }
}

.el-carousel {
  width: 100%;
  height: 100%;

  .el-image {
    width: 100%;
    height: 100%;
  }

  /deep/ .el-carousel__container {
    height: calc(100% - 26px);
  }
}
</style>

<style lang='scss'>
.el-image-viewer__img {
  min-width: 30%;
  max-height: 90% !important;
}
</style>
